import React from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";

const Navbar = () => {
  return (
    <nav className="navbar">
      <Link to="/SignIn">SignIn</Link> 
      <Link to="/SignUp">SignUp</Link> 
      <Link to="/">Home</Link>
      <Link to="/products">Products</Link>
      <Link to="/cart">Cart</Link>
      <Link to="/review">Review</Link> 
      

    </nav>
  );
};

export default Navbar;
